export default __webpack_public_path__ + "static/media/nirav@4x.0efd5735.png";